import { COMMON_META, TRUST_INTERSTITIAL } from './shared';

// 60 / 125 / 160-biomarker blood panel (auto-authorized) — /lab-panel.
const stages = ['Start', 'Profile', 'Address', 'Consent', 'Checkout'];

const meta = {
  ...COMMON_META('Profile'),
  'basic-contact': { stage: 'Start', headline: ['Up to 160 biomarkers.', 'One simple blood draw.'], hint: 'We’ll send your requisition and results here.', image: 'labs/panel' },
  'sex-at-birth': { stage: 'Profile', headline: ['Let’s personalize', 'your panel.'], hint: 'Some reference ranges differ by sex.', image: 'labs/tube', optionIcons: { male: '👨', female: '👩' } },
  'shipping-address': { stage: 'Address', headline: ['Where should we', 'send your requisition?'], image: 'common/shipping' },
  'lab-consent': { stage: 'Consent', headline: ['The fine print,', 'made clear.'], image: 'common/consent' },
  'identity-verification': { stage: 'Consent', headline: ['Required by law —', 'and it protects you.'], image: 'common/id' },
  'dexa-upsell': { stage: 'Checkout', headline: ['See what the', 'scale can’t.'], image: null },
  checkout: { stage: 'Checkout', headline: ['Ready when', 'you are.'], image: null },
  'ix-trust': { stage: 'Start' }, 'ix-what': { stage: 'Profile' },
};

const interstitials = [
  TRUST_INTERSTITIAL('ix-trust', 'basic-contact', { plain: 'Know your numbers.', accent: 'All of them.', banner: 'Comprehensive lab testing', rank: '160', title: 'biomarkers in our most complete panel', bullets: ['Hormones, metabolic, thyroid, lipids, vitamins, inflammation and more', 'Provider-authorized instantly — no appointment to book first', 'Draw at a nearby partner lab', 'Results in your dashboard, reviewed by a licensed provider'] }),
  {
    id: 'ix-what', after: 'sex-at-birth', kind: 'curve', plain: 'What happens', accent: 'after you order?',
    yLabel: ['Clarity about', 'your health'], arrowLabel: ['Action', 'plan'], xLabels: ['Today', 'Day 1–3', 'Day 3–7', 'Day 7+'],
    bullets: ['– Today: your requisition is authorized and emailed to you', '– Days 1–3: walk into a partner lab for the draw', ['– Days 3–7: results land in your dashboard with ', 'provider feedback']],
  },
];

const labPanel = {
  key: 'labPanel', route: '/lab-panel', title: 'Comprehensive Lab Panel', stages, fallbackStage: 'Profile',
  stageDefaults: {
    Start: { headline: ['Up to 160 biomarkers.', 'One simple blood draw.'], image: 'labs/panel' },
    Profile: { headline: ['Let’s personalize', 'your panel.'], image: 'labs/tube' },
    Address: { headline: ['Where should we', 'send your requisition?'], image: 'common/shipping' },
    Consent: { headline: ['The fine print,', 'made clear.'], image: 'common/consent' },
    Checkout: { headline: ['Ready when', 'you are.'], image: null },
  },
  meta, interstitials,
};
export default labPanel;
